import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

export const ContentType = {
  DEFAULT: 'default',
  TWO_COLUMNS_LEFT: 'two-columns-left'
} as const
export type ContentType = (typeof ContentType)[keyof typeof ContentType]

interface Props extends ChildProps {
  type?: ContentType
}

const Content = ({ children, type = ContentType.DEFAULT }: Props) => {
  return (
    <div
      className={clsx(
        'flex flex-col gap-y-6',
        type == ContentType.TWO_COLUMNS_LEFT ? 'max-w-222 flex-1 shrink grow' : 'flex-1'
      )}
    >
      {children}
    </div>
  )
}

export default Content
